import { createContext, useCallback, useMemo, useState } from 'react';

/** Opt-in: a parameter picker becomes the next step of its containing dialog. */
type PickerSurface = {
  host: HTMLDivElement | null;
  present: (cancel: () => void) => void;
  dismiss: () => void;
};

export const GameParameterPickerSurfaceContext = createContext<PickerSurface | null>(null);

export const useGameParameterPickerSurface = () => {
  const [host, hostRef] = useState<HTMLDivElement | null>(null);
  const [cancel, setCancel] = useState<(() => void) | null>(null);
  const present = useCallback((close: () => void) => setCancel(() => close), []);
  const dismiss = useCallback(() => setCancel(null), []);
  const context = useMemo(() => ({ host, present, dismiss }), [host, present, dismiss]);
  return { context, hostRef, active: cancel != null, cancel };
};
